import styled from 'styled-components';

export const DividerLine = styled.hr`
  border: none;
  border-top: solid 1px #c5c5c5;
  margin: 30px 0 23px;
`;



// WEBPACK FOOTER //
// ./src/styles/DividerLine.js